import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, from, map, Observable, of, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  Upload(UploadDetail: any) {
    return this.http.post<any>(environment.API_URL + `File/Upload`,
      this.session.SetClass(UploadDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  CompanyParameter(Detail: any = {}): Observable<any> {
    return this.callWithRetry('CompanyParameter/Select', Detail);
    // return this.http.post<any>(environment.API_URL + `CompanyParameter/Select`,
    //   this.session.SetClass(Detail)
    // ).pipe(map(response => {
    //   if (response.Error_Code == '11' || response.Error_Code == '02') {
    //     this.session.End();
    //   } else {
    //     return response;
    //   }
    // }));

  }

  SelectDate(EmployeeDetail: any): Observable<any> {
    return this.callWithRetry('emp/SelectDate', EmployeeDetail);
    // return this.http.post<any>(environment.API_URL + `emp/SelectDate`,
    //   this.session.SetClass(EmployeeDetail)
    // ).pipe(map(response => {
    //   if (response.Error_Code == '11' || response.Error_Code == '02') {
    //     this.session.End();
    //   } else {
    //     return response;
    //   }
    // }));
  }

  GetDateTime(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `GetDate/GetDateTime`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  AdressDetailsGet(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `AdressDetails/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  getIPAddress() {
    return this.http.get<any>(`https://api.ipify.org/?format=json`).pipe(map(response => {
      return response;
    }));
  }

  Mobile_ESS_Get_LocalAuthDetails(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `Mobile_ESS_Get_LocalAuth/Details`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Mobile_ESS_Get_LocalAuthDetailsFromLogin(Detail: any = {}, API_URL: string) {
    return this.http.post<any>(API_URL + `Mobile_ESS_Get_LocalAuth/Details`,
      Detail
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Mobile_ESS_Update_LocalAuthUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `Mobile_ESS_Update_LocalAuth/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Mobile_ESS_Update_LocalAuthUpdateFromLogin(Detail: any = {}, API_URL: string) {
    return this.http.post<any>(API_URL + `Mobile_ESS_Update_LocalAuth/Update`,
      Detail
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_CentralizedLoginKeyGeneration(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `ESS_CentralizedLoginKey/Generation`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Ess_ChangePasswordUpdate(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `Ess_ChangePassword/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  LogOutDetails(Detail: any = {}) {
    return this.http.post<any>(environment.API_URL + `LogOut/Details`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  AdminAttendanceManagementEmployeesLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `AdminAttendanceManagement`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  // Create a generic function that can be reused
  public callWithRetry<T>(apiUrl: string, detail: any, retryCount: number = 0, useMainApi = false, checkenvurl = false): Observable<T> {
    const maxRetries = 2;
    return this.http.post<any>(useMainApi ? apiUrl : environment.API_URL + apiUrl,
      useMainApi ? detail : this.session.SetClass(detail),
      { observe: 'response' }
    ).pipe(
      switchMap((response: any) => {
        if (!this.session.notAllowReponseCode.includes(response.status)) {
          if (response.body?.Error_Code == '11' || response.body?.Error_Code == '02') {
            this.session.End();
            return of(null as any);
          }
          return of(response.body as T);
        } else {
          if (retryCount < maxRetries) {
            if (!checkenvurl) {
              return from(this.session.switchUrl(useMainApi ? new URL(apiUrl).origin + '/' : '')).pipe(
                switchMap((switched) => {
                  if (switched) {
                    environment.API_URL = this.session.GetUserDetails().ApiUrl;
                    if (useMainApi) {
                      apiUrl = this.replaceBaseUrl(apiUrl, this.session.GetUserDetails().ApiUrl);
                    }
                    return this.callWithRetry<T>(apiUrl, detail, retryCount + 1, useMainApi, checkenvurl);
                  } else {
                    this.LogOutDetails({ 'SelectType': 'LogOut', LoginName: this.session.GetUserDetails().LoginName }).subscribe({
                      next: (response) => {
                        if (response.Error_Code == "09")
                          this.session.End();
                      },
                      complete: () => { },
                      error: (error) => { },
                    });
                  }
                  return throwError(() => new Error(`Failed to switch URL`));
                })
              );
            } else {
              return this.callWithRetry<T>(environment.API_URL_MainSecondary + `GetCredentials`, detail, retryCount + 1, useMainApi, checkenvurl);
            }
          }
          return throwError(() => new Error(`Request failed`));
        }
      }),
      catchError((error: any) => {
        // Network error or no response received
        console.log('Network/Connection error:', error);

        if (retryCount < maxRetries) {
          if (!checkenvurl) {
            return from(this.session.switchUrl()).pipe(
              switchMap((switched) => {
                if (switched) {
                  environment.API_URL = this.session.GetUserDetails().ApiUrl;
                  if (useMainApi) {
                    apiUrl = this.replaceBaseUrl(apiUrl, this.session.GetUserDetails().ApiUrl);
                  }
                  return this.callWithRetry<T>(apiUrl, detail, retryCount + 1, useMainApi, checkenvurl);
                } else {
                  this.LogOutDetails({ 'SelectType': 'LogOut', LoginName: this.session.GetUserDetails().LoginName }).subscribe({
                    next: (response) => {
                      if (response.Error_Code == "09")
                        this.session.End();
                    },
                    complete: () => { },
                    error: (error) => { },
                  });
                }
                return throwError(() => new Error(`Failed to switch URL`));
              })
            );
          } else {
            return this.callWithRetry<T>(environment.API_URL_MainSecondary + `GetCredentials`, detail, retryCount + 1, useMainApi, checkenvurl);
          }
        }

        return throwError(() => new Error(`Request failed: ${error.message || 'Unknown error'}`));
      })
    );
  }

  replaceBaseUrl(originalUrl: string, newBaseUrl: string): string {
    // Parse the original URL
    const urlObj = new URL(originalUrl);

    // Create new URL with new base
    const newUrl = newBaseUrl.replace(/\/$/, '') + urlObj.pathname + urlObj.search + urlObj.hash;

    return newUrl;
  }
}
